import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/PublicHeader.css";
import logo from "../assets/logo.png";
import fao from "../assets/fao.png";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const PublicHeader: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleOnClick = () => {
    navigate("/login");
  }

  const getRoleText = (role: string) => {
    switch(role) {
      case "Admin":
        return "Administrateur";
      default:
        return role;
    }
  }

  return (
    <header className="navbar public-header">
      <div className="container d-flex align-items-center justify-content-between py-2">
        <div className="d-flex align-items-center">
          <img src={logo} alt="Logo" className="public-header-logo" />
          <p className="public-header-logo-text">Ministère de l'Agriculture, de la Pêche, et de l'Artisanat</p>
        </div>

        <div className="d-flex align-items-center" style={{ height:"100%", padding:"0.5vh 0.5vw"}}>
          {user ? (
            <button onClick={handleOnClick} className="ms-2 btn-conn">
              {getRoleText(user.role)}
            </button>
          ) : (
            <button onClick={handleOnClick} className="ms-2 btn-conn">
              Se connecter
            </button>
          )}
        </div>

      </div>
    </header>
  );
};

export default PublicHeader;